import type React from 'react'

import css from './styles.module.css'

export const Spinner: React.FC = () => (
  <div className={css.spinner}>
    <div className={css.bar} />
    <div className={css.bar} />
    <div className={css.bar} />
    <div className={css.bar} />
    <div className={css.bar} />
    <div className={css.bar} />
    <div className={css.bar} />
    <div className={css.bar} />
  </div>
)
